/* Doe-het-zelf-zaak: stucloper-calculator */
function dhzCalc(root) {
  function $(k) { return root.querySelector('[data-c="' + k + '"]'); }
  var cfg = JSON.parse(root.querySelector('[data-dhz-calc-config]').textContent);
  /* Rolsoorten uit de varianten halen: "50 m² - 130 cm" geeft 50 m² en 1,30 m breed. Rollengte = m² / breedte. */
  var types = [];
  cfg.variants.forEach(function (v) {
    var m2 = /(\d+(?:[.,]\d+)?)\s*m(?:²|2)/i.exec(v.title), cm = /(\d+(?:[.,]\d+)?)\s*cm/i.exec(v.title);
    if (!m2 || !cm || !v.available) return;
    var w = parseFloat(cm[1].replace(',', '.')) / 100, a = parseFloat(m2[1].replace(',', '.'));
    types.push({ id: String(v.id), m2: a, w: w, len: a / w, price: v.price / 100, name: 'Rol ' + m2[1] + ' m² · ' + cm[1] + ' cm breed' });
  });
  if (!types.length) { root.hidden = true; return; }
  types.sort(function (a, b) { return b.w - a.w; });
  var ROLLS = { w130: types[0], w65: types[types.length - 1] };
  var ONE = types.length === 1;
  var TAPE_LEN = cfg.tapeLength || 33, CUT = 0.03; // 3 cm snijmarge per baan
  var overlap = 0.10, plinth = false, active = 0;

  var SHAPES = {
    rect: { label: 'Rechthoek', fields: [['A', 'Lengte'], ['B', 'Breedte']],
      icon: '<rect x="3" y="3" width="28" height="20" fill="none" stroke="currentColor" stroke-width="2"/>',
      fig: '<rect x="10" y="10" width="90" height="62" fill="#EFF0F5" stroke="#0E1B4D" stroke-width="2"/><text x="55" y="84" class="t">A</text><text x="104" y="45" class="t">B</text>' },
    l: { label: 'L-vorm', fields: [['A', 'Totale lengte'], ['B', 'Totale breedte'], ['a', 'Lengte uitsparing'], ['b', 'Breedte uitsparing']],
      icon: '<path d="M3 3h28v10h-12v10H3z" fill="none" stroke="currentColor" stroke-width="2"/>',
      fig: '<path d="M10 10h90v32h-38v30H10z" fill="#EFF0F5" stroke="#0E1B4D" stroke-width="2"/><path d="M62 42h38v30H62z" fill="none" stroke="#0E1B4D" stroke-dasharray="3 3"/><text x="55" y="8" class="t">A</text><text x="4" y="45" class="t">B</text><text x="81" y="84" class="t">a</text><text x="106" y="60" class="t">b</text>' },
    trap: { label: 'Schuine muur', fields: [['A', 'Lange zijde'], ['C', 'Korte zijde'], ['B', 'Breedte']],
      icon: '<path d="M3 3h28l-12 20H3z" fill="none" stroke="currentColor" stroke-width="2"/>',
      fig: '<path d="M10 10h90L60 72H10z" fill="#EFF0F5" stroke="#0E1B4D" stroke-width="2"/><text x="55" y="8" class="t">A</text><text x="35" y="84" class="t">C</text><text x="4" y="45" class="t">B</text>' },
    area: { label: 'Ik ken de m²', fields: [['M', 'Oppervlakte (m²)']],
      icon: '<text x="17" y="19" text-anchor="middle" font-size="12" font-weight="700" fill="currentColor">m²</text>',
      fig: '<text x="55" y="48" text-anchor="middle" class="t" font-size="16">m²</text>' }
  };

  var rooms = [], current = [];
  var box = $('rooms');
  function num(v) { v = parseFloat(String(v).replace(',', '.')); return isNaN(v) || v < 0 ? 0 : v; }
  function fmt(v, d) { d = d === undefined ? 1 : d; var p = Math.pow(10, d); return (Math.round(v * p) / p).toString().replace('.', ','); }
  function euro(v) { return '€' + v.toFixed(2).replace('.', ','); }

  /* Breedte van de ruimte op hoogte y, gemeten in de legrichting */
  function geom(r) {
    var v = r.v, g = null;
    if (r.shape === 'rect' && v.A > 0 && v.B > 0) {
      g = { H: v.B, ext: function () { return v.A; }, brk: [], area: v.A * v.B, per: 2 * (v.A + v.B),
            poly: [[0,0],[v.A,0],[v.A,v.B],[0,v.B]] };
    } else if (r.shape === 'l' && v.A > 0 && v.B > 0 && v.a > 0 && v.b > 0 && v.a < v.A && v.b < v.B) {
      g = { H: v.B, ext: function (y) { return y < v.B - v.b - 1e-9 ? v.A : v.A - v.a; }, brk: [v.B - v.b],
            area: v.A * v.B - v.a * v.b, per: 2 * (v.A + v.B),
            poly: [[0,0],[v.A,0],[v.A,v.B - v.b],[v.A - v.a,v.B - v.b],[v.A - v.a,v.B],[0,v.B]] };
    } else if (r.shape === 'trap' && v.A > 0 && v.C > 0 && v.B > 0 && v.C <= v.A) {
      var sl = Math.sqrt(Math.pow(v.A - v.C, 2) + v.B * v.B);
      g = { H: v.B, ext: function (y) { return v.A - (v.A - v.C) * (y / v.B); }, brk: [],
            area: (v.A + v.C) / 2 * v.B, per: v.A + v.C + v.B + sl,
            poly: [[0,0],[v.A,0],[v.C,v.B],[0,v.B]] };
    }
    return g;
  }
  /* Draai de ruimte een kwartslag (banen in de andere richting) */
  function rotate(g) {
    var xs = g.poly.map(function (p) { return p[0]; });
    var W = Math.max.apply(null, xs);
    function ext(x) { // hoogte van de ruimte op positie x
      var ys = [];
      for (var i = 0; i < g.poly.length; i++) {
        var p = g.poly[i], q = g.poly[(i + 1) % g.poly.length];
        if ((p[0] - x) * (q[0] - x) <= 0 && p[0] !== q[0]) ys.push(p[1] + (q[1] - p[1]) * (x - p[0]) / (q[0] - p[0]));
      }
      return ys.length ? Math.max.apply(null, ys) - Math.min.apply(null, ys) : 0;
    }
    var brk = g.poly.map(function (p) { return p[0]; });
    return { H: W, ext: ext, brk: brk, area: g.area, per: g.per, rot: true, poly: g.poly };
  }
  /* Banen leggen met een bepaalde rolbreedte */
  function strips(g, w) {
    var step = w - overlap, out = [], y = 0, endAdd = 2 * (plinth ? 0.10 : 0) + CUT;
    var n = Math.max(1, Math.ceil((g.H - overlap) / step - 1e-9));
    for (var i = 0; i < n; i++) {
      var y0 = i * step, y1 = Math.min(g.H, y0 + w);
      var pts = [y0 + 1e-6, y1 - 1e-6].concat(g.brk.filter(function (b) { return b > y0 && b < y1; }));
      var L = 0;
      for (var k = 0; k < 20; k++) pts.push(y0 + (y1 - y0) * k / 19);
      pts.forEach(function (p) { L = Math.max(L, g.ext(Math.min(g.H, Math.max(0, p)))); });
      out.push({ y0: y0, y1: y1, len: L + endAdd, w: w });
    }
    return out;
  }
  /* Banen verdelen over rollen (grootste eerst), reststukken die te kort zijn vallen weg */
  function pack(pieces, rollLen) {
    var rolls = [];
    pieces.slice().sort(function (a, b) { return b - a; }).forEach(function (p) {
      while (p > rollLen + 1e-9) { rolls.push(0); p -= rollLen; }
      for (var i = 0; i < rolls.length; i++) if (rolls[i] >= p - 1e-9) { rolls[i] -= p; return; }
      rolls.push(rollLen - p);
    });
    return rolls.length;
  }
  function plan(mode) { // mode: 'w130' | 'w65' | 'mix'
    var pieces130 = [], pieces65 = [], layout = [], seams = 0, per = 0, area = 0, freeArea = 0;
    rooms.forEach(function (r, idx) {
      if (r.shape === 'area') { freeArea += r.v.M; return; }
      var g = geom(r); if (!g) return;
      area += g.area; per += g.per;
      var best = null;
      var kinds = mode === 'auto' ? ['w130', 'w65', 'mix'] : [mode];
      [g, rotate(g)].forEach(function (gg) { kinds.forEach(function (kind) {
        var w = kind === 'w65' ? ROLLS.w65.w : ROLLS.w130.w;
        var st = strips(gg, w);
        if (kind === 'mix' && st.length >= 1) {
          var last = st[st.length - 1], rem = gg.H - last.y0;
          if (!ONE && rem <= ROLLS.w65.w + 1e-9) { var s65 = strips({ H: rem, ext: function (y) { return gg.ext(last.y0 + y); }, brk: gg.brk.map(function (b) { return b - last.y0; }) }, ROLLS.w65.w); st.pop(); s65.forEach(function (s) { s.y0 += last.y0; s.y1 += last.y0; st.push(s); }); }
        }
        var tot = st.reduce(function (t, s) { return t + s.len * s.w; }, 0);
        if (!best || tot < best.tot - 1e-9) best = { st: st, g: gg, tot: tot };
      }); });
      best.st.forEach(function (s) { (s.w === ROLLS.w130.w ? pieces130 : pieces65).push(s.len); });
      seams += best.st.slice(0, -1).reduce(function (t, s) { return t + s.len; }, 0);
      layout[idx] = best;
    });
    if (freeArea > 0) { // zonder vorm: schatting op basis van m² en overlap
      var w = mode === 'w65' ? ROLLS.w65.w : ROLLS.w130.w, run = freeArea / (w - overlap) * 1.05;
      var R = mode === 'w65' ? ROLLS.w65 : ROLLS.w130;
      var full = Math.floor(run / R.len), rest = run - full * R.len;
      var tgt = mode === 'w65' ? pieces65 : pieces130;
      for (var i = 0; i < full; i++) tgt.push(R.len);
      if (rest > 0) tgt.push(rest);
      per += 4 * Math.sqrt(freeArea); seams += run * 0.5;
    }
    var n130 = pieces130.length ? pack(pieces130, ROLLS.w130.len) : 0;
    var n65 = pieces65.length ? pack(pieces65, ROLLS.w65.len) : 0;
    return { n130: n130, n65: n65, cost: n130 * ROLLS.w130.price + n65 * ROLLS.w65.price, layout: layout,
             area: area + freeArea, per: per, seams: seams, strips: layout.reduce(function (t, l) { return t + (l ? l.st.length : 0); }, 0),
             run: pieces130.concat(pieces65).reduce(function (t, p) { return t + p; }, 0) };
  }

  function draw(res) {
    var svg = $('plan'), tabs = $('plantabs');
    tabs.innerHTML = '';
    rooms.forEach(function (r, i) {
      if (rooms.length < 2) return;
      var b = document.createElement('button'); b.type = 'button'; b.textContent = r.name || ('Ruimte ' + (i + 1));
      b.setAttribute('aria-pressed', i === active); b.onclick = function () { active = i; draw(res); }; tabs.appendChild(b);
    });
    var r = rooms[active], L = res.layout[active];
    if (!r || r.shape === 'area' || !L) {
      svg.innerHTML = '<text x="160" y="112" text-anchor="middle" fill="#C3CAE6" font-size="13" font-family="Questrial, sans-serif">' + (r && r.shape === 'area' ? 'Geen schets bij een opgegeven m²' : 'Vul je maten in') + '</text>'; return;
    }
    var poly = L.g.poly.map(function (p) { return L.g.rot ? [p[1], p[0]] : p; });
    var W = Math.max.apply(null, poly.map(function (p) { return p[0]; })), H = L.g.H;
    var s = Math.min(280 / W, 170 / H), x0 = (320 - W * s) / 2, y0 = 12 + (170 - H * s) / 2;
    var id = 'clip' + root.id + active, d = poly.map(function (p, i) { return (i ? 'L' : 'M') + (x0 + p[0] * s) + ' ' + (y0 + p[1] * s); }).join(' ') + 'Z';
    var out = '<defs><clipPath id="' + id + '"><path d="' + d + '"/></clipPath></defs><g clip-path="url(#' + id + ')">';
    L.st.forEach(function (st, i) {
      out += '<rect x="' + x0 + '" y="' + (y0 + st.y0 * s) + '" width="' + (W * s) + '" height="' + ((st.y1 - st.y0) * s) + '" fill="#F9DD00" fill-opacity="' + (st.w !== ROLLS.w130.w ? 0.6 : (i % 2 ? 0.28 : 0.42)) + '" stroke="#F9DD00" stroke-opacity=".8"/>';
    });
    out += '</g><path d="' + d + '" fill="none" stroke="#fff" stroke-width="1.5"/>';
    var n130 = L.st.filter(function (x) { return x.w === ROLLS.w130.w; }).length, n65 = L.st.length - n130;
    var lbl = (n130 ? n130 + '× ' + Math.round(ROLLS.w130.w * 100) + ' cm' : '') + (n130 && n65 ? ' + ' : '') + (n65 ? n65 + '× ' + Math.round(ROLLS.w65.w * 100) + ' cm' : '');
    out += '<text x="160" y="212" text-anchor="middle" fill="#C3CAE6" font-size="12" font-family="Questrial, sans-serif">' + L.st.length + ' banen (' + lbl + ')</text>';
    svg.innerHTML = out;
  }

  function calc() {
    var opts = ['w130', 'w65', 'mix', 'auto'].map(plan).filter(function (o) { return o.n130 + o.n65 > 0; });
    var best = opts.sort(function (a, b) { return a.cost - b.cost || (a.n130 + a.n65) - (b.n130 + b.n65); })[0] || plan('w130');
    var el = $('r-m2'), t = fmt(best.area);
    if (el.textContent !== t) { el.textContent = t; el.classList.remove('num-pop'); void el.offsetWidth; el.classList.add('num-pop'); }
    var cover = best.n130 * ROLLS.w130.m2 + best.n65 * ROLLS.w65.m2;
    $('r-detail').textContent = best.area > 0 ? best.strips + ' banen, samen ' + fmt(best.run) + ' m lang. Je koopt ' + cover + ' m² aan rollen.' : '';
    var ul = $('r-rolls'); ul.innerHTML = '';
    if (best.n130) ul.innerHTML += '<li><span><b>' + best.n130 + '×</b> ' + ROLLS.w130.name + '</span><span>' + euro(best.n130 * ROLLS.w130.price) + '</span></li>';
    if (best.n65 && !ONE) ul.innerHTML += '<li><span><b>' + best.n65 + '×</b> ' + ROLLS.w65.name + '</span><span>' + euro(best.n65 * ROLLS.w65.price) + '</span></li>';
    if (!ul.innerHTML) ul.innerHTML = '<li><span>Vul je maten in</span><span></span></li>';
    $('r-price').textContent = euro(best.cost);
    var tape = best.area > 0 ? Math.ceil((best.per + best.seams) / TAPE_LEN) : 0;
    $('r-tape').innerHTML = tape ? 'Tip: om de randen en naden vast te plakken heb je ongeveer <b>' + tape + ' rol' + (tape > 1 ? 'len' : '') + '</b> ' + (cfg.tapeUrl ? '<a href="' + cfg.tapeUrl + '">renovatietape</a>' : 'renovatietape') + ' (33 m) nodig.' : '';
    var parts = [];
    if (best.n130) parts.push(ROLLS.w130.id + ':' + best.n130);
    if (best.n65 && !ONE) parts.push(ROLLS.w65.id + ':' + best.n65);
    var add = $('r-add');
    add.disabled = !parts.length;
    current = parts.map(function (p) { var x = p.split(':'); return { id: Number(x[0]), quantity: Number(x[1]) }; });
    if (active >= rooms.length) active = 0;
    draw(best);
  }

  function render(r, i) {
    var el = r.el;
    var S = SHAPES[r.shape];
    var html = '<div class="room-head"><label>Ruimte<input type="text" class="rname" value="' + r.name + '"></label>' +
      '<button type="button" class="rm" aria-label="Ruimte verwijderen">×</button></div><div class="shapes" role="group" aria-label="Vorm van de ruimte">';
    Object.keys(SHAPES).forEach(function (k) {
      html += '<button type="button" class="shape" data-s="' + k + '" aria-pressed="' + (k === r.shape) + '"><svg viewBox="0 0 34 26">' + SHAPES[k].icon + '</svg>' + SHAPES[k].label + '</button>';
    });
    html += '</div><div class="dims"><svg class="dimfig" viewBox="0 0 116 90" aria-hidden="true"><style>.t{font:700 11px Questrial,sans-serif;fill:#0E1B4D;text-anchor:middle}</style>' + S.fig + '</svg><div class="dimfields">';
    S.fields.forEach(function (f) {
      var val = r.v[f[0]] ? fmt(r.v[f[0]], 2) : '';
      html += '<label><span><span class="k">' + f[0] + '</span>' + f[1] + '</span><input type="text" inputmode="decimal" data-k="' + f[0] + '" value="' + val + '" placeholder="' + (f[0] === 'M' ? 'm²' : 'meter') + '"></label>';
    });
    html += '<p class="warn" hidden></p></div></div>';
    el.innerHTML = html;
    el.querySelector('.rname').addEventListener('input', function (e) { r.name = e.target.value; calc(); });
    el.querySelector('.rm').addEventListener('click', function () { rooms.splice(rooms.indexOf(r), 1); el.remove(); calc(); });
    el.querySelectorAll('.shape').forEach(function (b) { b.addEventListener('click', function () { r.shape = b.dataset.s; render(r); active = rooms.indexOf(r); calc(); }); });
    el.querySelectorAll('[data-k]').forEach(function (inp) {
      inp.addEventListener('input', function () { r.v[inp.dataset.k] = num(inp.value); validate(r); active = rooms.indexOf(r); calc(); });
    });
    validate(r);
  }
  function validate(r) {
    var w = r.el.querySelector('.warn'), msg = '', v = r.v;
    r.el.querySelectorAll('[data-k]').forEach(function (i) { i.classList.remove('bad'); });
    if (r.shape === 'l' && v.A && v.a && v.a >= v.A) msg = 'De uitsparing (a) moet korter zijn dan de totale lengte (A).';
    if (r.shape === 'l' && v.B && v.b && v.b >= v.B) msg = 'De uitsparing (b) moet smaller zijn dan de totale breedte (B).';
    if (r.shape === 'trap' && v.A && v.C && v.C > v.A) msg = 'De korte zijde (C) kan niet langer zijn dan de lange zijde (A).';
    [['A','B'],['A','C'],['B','C']].forEach(function () {});
    Object.keys(v).forEach(function (k) { if (v[k] > 100) msg = 'Kijk je maten na: we rekenen in meter (bv. 4,5).'; });
    w.hidden = !msg; w.textContent = msg;
  }
  function addRoom(name, shape, v) {
    var r = { name: name, shape: shape, v: v || {}, el: document.createElement('div') };
    r.el.className = 'room'; rooms.push(r); box.appendChild(r.el); render(r); calc();
  }
  $('addroom').addEventListener('click', function () { addRoom('Ruimte ' + (rooms.length + 1), 'rect', {}); active = rooms.length - 1; calc(); });
  root.querySelectorAll('[data-c="ov"] button').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-c="ov"] button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true'); overlap = parseInt(b.dataset.v, 10) / 100; calc();
    });
  });
  $('plinth').addEventListener('change', function (e) { plinth = e.target.checked; calc(); });
  $('r-add').addEventListener('click', function () {
    if (!current.length) return;
    var btn = this, drawer = document.querySelector('cart-drawer');
    btn.classList.add('loading'); btn.setAttribute('aria-busy', 'true');
    var body = { items: current };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { window.location = '/cart'; return; }
      if (drawer && res.sections && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
      else { window.location = '/cart'; }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dhz-calc' });
    }).catch(function () { window.location = '/cart'; }).finally(function () { btn.classList.remove('loading'); btn.removeAttribute('aria-busy'); });
  });
  addRoom('Woonkamer', 'rect', { A: 5, B: 4 });
}
document.querySelectorAll('[data-dhz-calc]').forEach(dhzCalc);
document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-dhz-calc]'); if (el) dhzCalc(el); });
